class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector("input");
        this.changeEvent = new Event("change", { bubbles: true });
        this.packSize = parseInt(this.input.dataset.packSize, 10) || 1;

        this.querySelectorAll("button").forEach((button) =>
            button.addEventListener("click", this.onButtonClick.bind(this))
        );

        if (this.packSize > 1) {
            this.input.addEventListener("change", this.snapToPack.bind(this));
            this.input.addEventListener("blur", this.snapToPack.bind(this));
        }
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        if (this.packSize > 1) {
            const min = parseInt(this.input.min, 10) || this.packSize;
            const allowZero = min === 0;
            let current = parseInt(this.input.value, 10);
            if (isNaN(current)) current = allowZero ? 0 : this.packSize;
            const delta = event.target.name === "plus" ? this.packSize : -this.packSize;
            let next = current + delta;
            if (next < min) next = min;
            if (allowZero && current === this.packSize && delta < 0) next = 0;
            this.input.value = next;
        } else {
            event.target.name === "plus"
                ? this.input.stepUp()
                : this.input.stepDown();
        }

        if (previousValue !== this.input.value)
            this.input.dispatchEvent(this.changeEvent);
    }

    snapToPack() {
        const min = parseInt(this.input.min, 10);
        const minVal = isNaN(min) ? this.packSize : min;
        const raw = parseInt(this.input.value, 10);
        if (isNaN(raw)) {
            this.input.value = minVal === 0 ? this.packSize : minVal;
            return;
        }
        if (minVal === 0 && raw === 0) return;
        let snapped = Math.round(raw / this.packSize) * this.packSize;
        if (snapped < this.packSize) snapped = this.packSize;
        if (String(snapped) !== this.input.value) {
            this.input.value = snapped;
        }
    }
}

customElements.define("quantity-input", QuantityInput);
